import Service from "./Service"

class PartnerService extends Service {

    findById = (id) => this.get(`/partners/${id}`)

    search = (queryParams) => this.getWithParams("/partners", queryParams)

    create = (request) => this.post("/partners", request)

    update = (id, request) => this.patch(`/partners/${id}`, request)

    delete = (id) => this.del(`/partners/${id}`)
}

const partnerService = new PartnerService()
export default partnerService